import { render, staticRenderFns } from "./PeriodicalsList.vue?vue&type=template&id=dd0175fe&scoped=true&"
import script from "./PeriodicalsList.vue?vue&type=script&lang=js&"
export * from "./PeriodicalsList.vue?vue&type=script&lang=js&"
import style0 from "./PeriodicalsList.vue?vue&type=style&index=0&id=dd0175fe&scoped=true&lang=scss&"
import style1 from "./PeriodicalsList.vue?vue&type=style&index=1&id=dd0175fe&lang=scss&scoped=true&"
import style2 from "./PeriodicalsList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0175fe",
  null
  
)

export default component.exports